import ModalCloseIcon from "@/components/icons/modal-close-icon";
import { Button } from "@/components/ui/button";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";

// import Invite from './invite';
import SearchInput from "./search-input";
import SelectedUsers from "./selected-users";
import type { UserType } from "./types";

interface HeaderProps {
  buttonLabel: string;
  onClose(): void;
  onSearch(query: string): void;
  onSubmit(): void;
  onToggle(user: UserType): void;
  readonlyUsers: string[];
  title: string;
  users: UserType[];
}

export default function Header({
  buttonLabel,
  onClose,
  onSearch,
  onSubmit,
  onToggle,
  readonlyUsers,
  title,
  users,
}: HeaderProps) {
  return (
    <DialogHeader className="gap-0">
      <div className="relative flex h-[65px] items-center justify-center border-white/10 border-b">
        <Button
          aria-label="Close"
          className="absolute top-1/2 left-6 flex size-[25px] -translate-y-1/2 rounded-full border border-white"
          onClick={onClose}
        >
          <ModalCloseIcon />
        </Button>
        <DialogTitle className="text-center text-16/[1.5em] text-white">
          {title}
        </DialogTitle>
        <Button
          className="absolute top-0 right-0 h-full px-6 font-semibold text-14 text-white"
          onClick={onSubmit}
        >
          {buttonLabel}
        </Button>
      </div>
      <div className="mt-5 flex flex-col items-stretch gap-5">
        {!!users.length && (
          <SelectedUsers
            onToggle={onToggle}
            readonlyUsers={readonlyUsers}
            users={users}
          />
        )}
        <SearchInput onSearch={onSearch} />
        {/* <Invite /> */}
      </div>
    </DialogHeader>
  );
}
